import React, { memo } from 'react';
import { Text } from 'react-native';

import { fonts } from '../style/fonts';
import { useResponsiveStyles } from '../hooks';
import AppStyles from '../AppStyles';

const getFont = (font) => {
  switch (font) {
    case 'black':
      return fonts.POPPINS.black;
    case 'extraBold':
      return fonts.POPPINS.extraBold;
    case 'bold':
      return fonts.POPPINS.bold;
    case 'semiBold':
      return fonts.POPPINS.semiBold;
    case 'medium':
      return fonts.POPPINS.medium;
    case 'regular':
      return fonts.POPPINS.regular;
    case 'light':
      return fonts.POPPINS.light;
    case 'extraLight':
      return fonts.POPPINS.extraLight;
    case 'thin':
      return fonts.POPPINS.thin;
    default:
      return fonts.POPPINS.regular;
  }
};

const CustomText = memo(function CustomText(props) {
  const { isWeb, screenWidth } = useResponsiveStyles();

  // Adjust fonts for viewing the web portal on smaller devices
  const scale = isWeb && screenWidth < 800 ? 0.7 : 1;

  return (
    <Text
      adjustsFontSizeToFit={true}
      allowFontScaling={true}
      maxFontSizeMultiplier={2.0}
      style={[
        {
          fontFamily: getFont(props.font, props.family),
          fontSize: props.size != undefined ? props.size * scale : 14 * scale,
          color: props.color != undefined ? props.color : AppStyles.colorSet.textPrimary,
        },
        props.style,
      ]}
    >
      {props.children}
    </Text>
  );
});

export default CustomText;
